const stingers = [
  "BT_019t",
  "BT_028t",
  "BT_109t",
  "BT_123t",
  "BT_136t",
  "BT_197t",
  "BT_210t",
  "BT_309t",
  "BT_713t",
  "ULD_705t",
  "UNG_940t8",
  "UNG_116t",
  "UNG_954t1",
  "UNG_942t",
  "UNG_920t1",
  "BGS_120",
  "SW_039t3_t",
  "SW_428t4",
  "SW_322t4",
  "SW_450t4",
  "SW_313t4",
  "SW_433t3",
  "SW_052t3",
  "SW_031t7",
  "SW_091t4",
  "SW_028t5",
]

export default stingers
